<script setup>
// Fork Oito: Funil (CRM) servido pelo oito-crm em /crm/, mesma origem do Chatwoot.
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const src = computed(() =>
  route.name === 'oito_funil_quadro' ? '/crm/funil.html' : '/crm/fila.html'
);
</script>

<template>
  <div class="flex flex-col flex-1 w-full h-full min-h-0">
    <iframe :key="src" :src="src" class="w-full h-full border-0" />
  </div>
</template>
